import { useQuery } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialitySurveysApi } from "@api/services";

export const ACTION_GET_ACTIVATION_STATS = "GET_ACTIVATION_STATS";

export interface ActivationStats {
  newStakeholdersCount: number;
  allStakeholdersCount: number;
}

const getActivationStats = async (surveyId: string): Promise<ActivationStats> => {
  const res =
    await doubleMaterialitySurveysApi.doubleMaterialitySurveysControllerGetActivationStats(
      surveyId
    );

  return res.data;
};

export const useGetActivationStats = (
  user: UserProfileDto | null,
  surveyId: string,
  enabled: boolean = true
): {
  stats?: ActivationStats;
  isPending: boolean;
  isError: boolean;
  refetchStats: () => void;
} => {
  const statsEnabled =
    enabled && roleGuard(user, [UserRole.Owner, UserRole.Manager]);

  const { data, isPending, isError, refetch } = useQuery({
    queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_ACTIVATION_STATS, surveyId],
    queryFn: () => getActivationStats(surveyId),
    enabled: statsEnabled && !!surveyId,
    retry: false,
  });

  return {
    stats: data,
    isPending,
    isError,
    refetchStats: refetch,
  };
};
